<template>
  <div class="page-header">
    <b-row>
      <b-col class="title_PPage">
        <PIcon :icon="icon" :size="27" color="#FFD102" />
        <span class="header-title"> {{ title }} </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <slot></slot>
      </b-col>
    </b-row>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import PIcon from "@/components/look/PIcon/PIcon.vue";

@Component({
  components: {
    PIcon,
  },
})
export class PPage extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ required: false, default: "IconLogic" }) icon!: string;
}
export default PPage;
</script>
<style scoped>
.page-header {
  padding: 14px 9px;
}

.header-title {
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--secundario-prosegur-oscuro);
  padding-left: 14px;
}
.title_PPage {
  display: flex;
  align-items: center;
  padding-bottom: 1em;
}
</style>
